import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { navItems } from '../../_nav';

import { TranslateService } from '@ngx-translate/core';

import { NgEventBus } from 'ng-event-bus';
import { ContextService } from '../../auth/context.service';

import { Area, Customer, Role } from '../../shared/sdk/models';
import { AreaCustomerApi, CustomerApi, RoleMappingApi, WeldSessionApi } from '../../shared/sdk/services';

import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { ToastrService } from 'ngx-toastr';
import { CustomerFormComponent } from '../../views/system/customer/customer-form/customer-form.component';

@Component({
  selector: 'app-dashboard',
  styles: ['h4 { font-size: 1em; font-weight: bold; padding: 0 8px; } #profile { cursor: pointer; }'],
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;
  public loading: boolean = false;

  @ViewChild("customerEditForm", { read: ViewContainerRef })
  public customerEditFormRef: ViewContainerRef;

  // Languages list
  public DEFAULT_LANGUAGE = "es";
  public languages: Array<{ text: string, value: string }> = [
    { text: "Español", value: 'es' },
    { text: "Inglés", value: 'en' }
  ];

  public name: string;
  public language: string;
  public area: Area;
  public areas: Area[];
  private subscription: Array<any> = [];
  constructor(private translate: TranslateService,
    private eventBus: NgEventBus,
    private dialogService: DialogService,
    private customerApi: CustomerApi,
    private weldSessionApi: WeldSessionApi,
    private roleMappingApi: RoleMappingApi,
    private areaCustomerApi: AreaCustomerApi,
    private router: Router,
    private toastr: ToastrService,
    @Inject(DOCUMENT) _document?: any) {
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });

    this.element = _document.body;

    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });
    this.subscription.push(this.eventBus.on('event:sessions').subscribe(async (event: any) => {
      let machine = '', customer = '';
      let session: any
      if (event.weldSessionId !== undefined) {
        session = await this.weldSessionApi.findOne({ where: { id: event.weldSessionId }, include: ['machine', 'customer'] }).toPromise();
        machine = session.machine.name;
        customer = session.customer.lastName + ', ' + session.customer.firstName;
      }

      let msgTitle = event.statusSession == 'OPENNED' ? 'Session de soldadura Abierta' : 'Sesion de soldadura Cerrada';
      if (event.statusSession === 'OPENNED') {
        let date = '';
        if (session !== undefined && session.openDate !== undefined) {
          date = new Date(session.openDate).toLocaleString();
        }
        this.toastr.success(`<p><strong>Fecha:</strong> ${date}<br><strong>Maquina:</strong> ${machine}<br><strong>Operario:</strong> ${customer}</p>`, msgTitle, {
          timeOut: 6000,
          closeButton: true,
          progressBar: true,
          enableHtml: true,
        });
      } else {
        let date = '';
        if (session !== undefined && session.closeDate !== undefined && session.closeButton !== null) {
          date = new Date(session.closeDate).toLocaleString();
        }
        this.toastr.info(`<p><strong>Fecha:</strong> ${date}<br><strong>Maquina:</strong> ${machine}<br><strong>Operario:</strong> ${customer}</p>`, msgTitle, {
          timeOut: 6000,
          closeButton: true,
          progressBar: true,
          enableHtml: true
        });
      }
    }));
  }

  ngOnInit(): void {
    // set default customr language and translation
    if (ContextService.context.customer != undefined)
      this.language = ContextService.context.language;
    else
      this.language = this.DEFAULT_LANGUAGE;

    this.translate.use(this.language);

    // set customer name
    this.name = ContextService.context.customer.lastName + ', ' + ContextService.context.customer.firstName;

    // set customer areas
    this.areas = ContextService.context.customer.areas;

    // set default customer area
    this.area = ContextService.context.area;

    // configure menu from user role
    var isAdmin = false;
    console.log("Roles: ", ContextService.context.customer.roles);
    ContextService.context.customer.roles.forEach((role: Role) => {
      if (role.name === 'admin') {
        isAdmin = true
      }
    });

    if (!isAdmin)
      this.navItems = this.navItems.filter(menu => menu.attributes.system !== true)

    // menu translation
    this.navItems.forEach(navItem => navItem.name = this.translate.instant("MENU." + navItem.key));
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }

  public areaChange(area: any): void {
    // set active area
    ContextService.context.area = area

    // emit area set active event
    this.eventBus.cast('area:active', area);
  }

  public languageChange(language: any): void {
    // set active area
    ContextService.context.language = language;

    // set new language
    this.translate.use(language);

    // menu translation
    this.navItems.forEach(navItem => navItem.name = this.translate.instant("MENU." + navItem.key));
  }

  public profile() {
    const customer: Customer = ContextService.context.customer;

    const dialogRef = this.dialogService.open({
      appendTo: this.customerEditFormRef,
      content: CustomerFormComponent,
      title: 'Edición Usuario',
      width: 700
    });

    const customerEditForm = dialogRef.content.instance;
    customerEditForm.model = customer;

    dialogRef.result.subscribe((customer: any) => {
      if (!(customer instanceof DialogCloseResult)) {
        this.loading = true;

        // STEP01: update customer
        this.customerApi.updateAttributes(customer.id, customer).subscribe((result: any) => {
          this.loading = false;

          // STEP02: update areas
          this.customerApi.deleteAreas(customer.id).subscribe((result: any) => {
            var customerAreas = [];
            customer.areas.forEach(area => customerAreas.push({ customerId: customer.id, areaId: area.id }));

            this.areaCustomerApi.create(customerAreas).subscribe((result: any) => {
              // STEP03: update roles
              this.customerApi.deleteRoles(customer.id).subscribe((result: any) => {
                var customerRoles = [];
                customer.roles.forEach(role => customerRoles.push({ principalId: customer.id, principalType: 'USER', roleId: role.id }));

                this.roleMappingApi.create(customerRoles).subscribe((result: any) => {
                  console.log(result);
                },
                  err => {
                    console.log(err);
                    this.loading = false;
                  });
              },
                err => {
                  console.log(err);
                  this.loading = false;
                });
            },
              err => {
                console.log(err);
                this.loading = false;
              });
          },
            err => {
              console.log(err);
              this.loading = false;
            });
        },
          err => {
            console.log(err);
            this.loading = false;
          });
      }
    });
  }

  public logout() {
    this.customerApi.logout().subscribe(result => {
      this.router.navigate(['/login']);
    });
  }
}
